import React from 'react';
import { AppThemeColorVariant, AppThemeFontVariant } from '../../../types/theme';
import { THEME_FONTS } from '../../theme/font';
import { THEME_PALETTE } from '../../theme/palette';

interface ITypography {
   variant?: AppThemeFontVariant;
   children: string | string[] | React.ReactNode;
   className?: string;
   style?: React.CSSProperties;
   colorVariant?: AppThemeColorVariant;
}

export default function Typography({
  variant = 'paragraph',
  colorVariant = 'text',
  className,
  children,
  style,
}: ITypography) {

  const themeStyle = React.useMemo((): React.CSSProperties => {
    return {
      ...THEME_FONTS[variant],
    }
  }, [variant]);

  const color = React.useMemo(() => {
    return {
      color: THEME_PALETTE[colorVariant]
    }
  }, [colorVariant]);

  return (
    <p style={{
      ...themeStyle,
      ...color,
      ...style
    }} 
    className={className}>
      {children}
    </p>
  )
}